import { Navigate, NavigateProps, useParams } from 'react-router-dom';
import { useStore } from 'ra-core';

type Props = Omit<NavigateProps, 'to'> & { to?: string };

const NavigateAdvertiserIdPrefix = ({
  to = '/campaigns/active',
  ...props
}: Props) => {
  const { advertiserId } = useParams<{ advertiserId: string }>();
  const [advertiserIdFromStore] = useStore<string | undefined>('advertiser_id');

  const id = advertiserId || advertiserIdFromStore;

  return <Navigate {...props} to={`/advertiser/${id}${to}`} />;
};

export default NavigateAdvertiserIdPrefix;
